export default "__VITE_ASSET__3ofy4gzk__"